import { useState } from 'react';
import useKeyboardListFocus from 'hooks/useKeyboardListFocus';

export const useKeyboardAutocompleteResults = (onKeyDownCallBack) => {
  const [shouldHideResults, setShouldHideResults] = useState(false);

  const onEscapeKeyDown = () => {
    onKeyDownCallBack && onKeyDownCallBack();
    setShouldHideResults(true);
  };

  const { inputRef, listRef, getOnKeyDown } = useKeyboardListFocus({
    onEscape: onEscapeKeyDown,
  });

  const onKeyDown = () => getOnKeyDown(onEscapeKeyDown);

  return {
    inputRef,
    listRef,
    getOnKeyDown,
    onKeyDown,
    setShouldHideResults,
    shouldHideResults,
  };
};
